import React, { useState, useEffect, useRef } from "react";

import { Card, Grid, Box, CardContent, Divider } from "@mui/material";

import { useTranslation } from "react-i18next";
import Vendor from "../AdminDashboard/Dashboard/VendorDashboard";

export default function VendorDashboard() {
  const { t } = useTranslation();

  return (
    <>
      {/* <Card style={{ marginTop: "1rem", marginBottom: "1rem", border: "none" }}>
        <h3 className="p-4">Vendor Dashboard</h3>
      </Card> */}
      <Vendor/>
    </>
  );
}
